import { inject } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { CanDeactivateFn } from '@angular/router';
import { ConfirmDialogService } from '@jfw/angular/wholesale/modals/confirm-dialog';

// Implemented by every Receipt Setup tab. Each one saves per section (or per
// form), so leaving a tab with an edit that was never saved silently threw
// it away (EXT-6481).
export interface HasUnsavedChanges {
  hasUnsavedChanges(): boolean;
}

export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = (
  component,
) => {
  if (!component?.hasUnsavedChanges()) {
    return true;
  }
  return inject(ConfirmDialogService).confirm({
    title: 'Unsaved changes',
    message:
      'You have changes on this page that have not been saved. Leave and discard them?',
    confirmLabel: 'Discard changes',
    cancelLabel: 'Stay',
  });
};

// A save can take a few seconds. Mark the form saved only if nothing was
// edited while it was in flight; otherwise the newer edit would read as saved
// and the guard would let the dealer leave without it.
export function markPristineIfUnchanged(
  form: AbstractControl,
  submitted: string,
): void {
  if (JSON.stringify(form.getRawValue()) === submitted) {
    form.markAsPristine();
  }
}
